import { branding } from './branding'

/**
 * Cal.com vendor wiring, derived from the one booking page configured in `branding`.
 * The namespace is the embed instance key, which Cal.com requires to be stable per booking page.
 */
export const SALES_CAL_NAMESPACE = branding.salesCalLink.slice(branding.salesCalLink.lastIndexOf('/') + 1)

export const SALES_BOOKING_URL = `https://cal.com/${branding.salesCalLink}`
